import {
  IMPRESSIONS,
  OTS_SGM_MNG_ACTIVE_IDS,
  OTS_SGM_MNG_AUDIENCE_ID,
  OTS_SGM_MNG_CPM,
  OTS_SGM_MNG_EFFECTIVE_CPM,
  OTS_SGM_MNG_LAST_UPDATED,
  OTS_SGM_MNG_POM,
  OTS_SGM_MNG_RECEIVED_IDS,
  OTS_SGM_MNG_REMODELING_CUT_SIZE,
  OTS_SGM_MNG_REMODELING_DELIVERED_SIZE,
  OTS_SGM_MNG_REMODELING_EXPORT_DATE,
  OTS_SGM_MNG_REMODELING_SEED_SIZE,
  OTS_SGM_MNG_REMODELING_STATUS,
  OTS_SGM_MNG_REVENUE,
} from '../../content';
import {
  RateLevel,
  SEGMENT_MANAGER_COLUMN_KEYS,
  SEGMENT_MANAGER_DEFAULT_PLATFORM,
} from '../../constants';

export const PLATFORM_OPTIONS = [
  {
    label: SEGMENT_MANAGER_DEFAULT_PLATFORM,
    value: SEGMENT_MANAGER_DEFAULT_PLATFORM,
  },
];

export const RATE_LEVEL_OPTIONS = [
  {
    label: 'OTS',
    value: RateLevel.SYSTEM,
  },
];

/**
 * Get TTD platform column configuration with sort state
 * @param sortBy - Current sort column
 * @param sortOrder - Current sort order ('ASC' | 'DESC')
 * @returns Array of column configurations with sort state
 */
export const getTtdColumns = (sortBy: string, sortOrder: 'ASC' | 'DESC') => [
  {
    title: OTS_SGM_MNG_RECEIVED_IDS,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.RECEIVED_IDS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.RECEIVED_IDS,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.RECEIVED_IDS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_ACTIVE_IDS,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.ACTIVE_IDS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.ACTIVE_IDS,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.ACTIVE_IDS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_CPM,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.CPM,
    width: '9%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.CPM,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.CPM ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_POM,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.POM,
    width: '7%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.POM,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.POM ? sortOrder : undefined,
  },
  {
    title: IMPRESSIONS,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.IMPRESSIONS,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.IMPRESSIONS,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.IMPRESSIONS
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_EFFECTIVE_CPM,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.EFFECTIVE_CPM,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.EFFECTIVE_CPM,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.EFFECTIVE_CPM
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_REVENUE,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.REVENUE,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.REVENUE,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.REVENUE
        ? sortOrder
        : undefined,
  },
  {
    title: OTS_SGM_MNG_LAST_UPDATED,
    column: SEGMENT_MANAGER_COLUMN_KEYS.TTD.LAST_UPDATED_AT,
    width: '11%',
    rightAlign: true,
    isSorted: sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.LAST_UPDATED_AT,
    sortOrder:
      sortBy === SEGMENT_MANAGER_COLUMN_KEYS.TTD.LAST_UPDATED_AT
        ? sortOrder
        : undefined,
  },
];

/**
 * Column keys for remodeling table
 */
export const REMODELING_COLUMN_KEYS = {
  EXPORT_DATE: 'exportDate',
  STATUS: 'status',
  CPM: 'cpm',
  POM: 'pom',
  CUT_SIZE: 'cutSize',
  SEED_SIZE: 'seedSize',
  DELIVERED_SIZE: 'deliveredSize',
  AUDIENCE_ID: 'audienceId',
};

/**
 * Get remodeling table column configuration with sort state
 * @param sortBy - Current sort column
 * @param sortOrder - Current sort order ('ASC' | 'DESC')
 * @returns Array of column configurations with sort state
 */
export const getRemodelingColumns = (
  sortBy: string,
  sortOrder: 'ASC' | 'DESC'
) => [
  {
    title: OTS_SGM_MNG_REMODELING_EXPORT_DATE,
    column: REMODELING_COLUMN_KEYS.EXPORT_DATE,
    width: '15%',
    isSorted: sortBy === REMODELING_COLUMN_KEYS.EXPORT_DATE,
    sortOrder:
      sortBy === REMODELING_COLUMN_KEYS.EXPORT_DATE ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_REMODELING_STATUS,
    column: REMODELING_COLUMN_KEYS.STATUS,
    width: '12%',
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_CPM,
    column: REMODELING_COLUMN_KEYS.CPM,
    width: '10%',
    rightAlign: true,
    isSorted: sortBy === REMODELING_COLUMN_KEYS.CPM,
    sortOrder: sortBy === REMODELING_COLUMN_KEYS.CPM ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_POM,
    column: REMODELING_COLUMN_KEYS.POM,
    width: '10%',
    rightAlign: true,
    isSorted: sortBy === REMODELING_COLUMN_KEYS.POM,
    sortOrder: sortBy === REMODELING_COLUMN_KEYS.POM ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_REMODELING_CUT_SIZE,
    column: REMODELING_COLUMN_KEYS.CUT_SIZE,
    width: '10%',
    rightAlign: true,
    isSorted: sortBy === REMODELING_COLUMN_KEYS.CUT_SIZE,
    sortOrder:
      sortBy === REMODELING_COLUMN_KEYS.CUT_SIZE ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_REMODELING_SEED_SIZE,
    column: REMODELING_COLUMN_KEYS.SEED_SIZE,
    width: '13%',
    rightAlign: true,
    isSorted: sortBy === REMODELING_COLUMN_KEYS.SEED_SIZE,
    sortOrder:
      sortBy === REMODELING_COLUMN_KEYS.SEED_SIZE ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_REMODELING_DELIVERED_SIZE,
    column: REMODELING_COLUMN_KEYS.DELIVERED_SIZE,
    width: '15%',
    rightAlign: true,
    isSorted: sortBy === REMODELING_COLUMN_KEYS.DELIVERED_SIZE,
    sortOrder:
      sortBy === REMODELING_COLUMN_KEYS.DELIVERED_SIZE ? sortOrder : undefined,
  },
  {
    title: OTS_SGM_MNG_AUDIENCE_ID,
    column: REMODELING_COLUMN_KEYS.AUDIENCE_ID,
    width: '14%',
    isSortDisabled: true,
    rightAlign: true,
  },
];

/**
 * Default remodeling schedule frequency in days
 */
export const DEFAULT_REMODELING_FREQUENCY = 30;

/**
 * Schedule frequency options for remodeling
 */
export const SCHEDULE_FREQUENCY_OPTIONS = [
  { label: 'every 7 days', value: 7 },
  { label: 'every 14 days', value: 14 },
  { label: 'every 30 days', value: 30 },
];
